//Config für DEV und Local
export default {
    apiUrl: "https://devapi.r2a-lehren-und-lernen.de",
    webSocketUrl: "wss://devapi.r2a-lehren-und-lernen.de"
}
